<template>
  <v-autocomplete
    hide-details="auto"
    :items="banks"
    :loading="loadingbanks"
    v-model="selectBank"
    item-text="name"
    item-value="id"
    label="Bank"
    outlined
    dense
    @change="emitInput"
    clearable
    :search-input.sync="searchBank"
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    banks: [],
    loadingbanks: false,
    selectBank: null,
    searchBank: null,
  }),
  methods: {
    emitInput() {
      this.$emit('input', this.selectBank);
    },
    GetBankByQuery(query = '') {
      this.loadingbanks = true;
      this.$store
        .dispatch('shop/getBankDetails', { query: query })
        .then((res) => {
          this.banks = res.data.data;
          this.loadingbanks = false;
        })
        .catch((err) => {
          this.loadingbanks = false;
          this.messages = err.data.name;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectBank = null;
        this.searchBank = null;
      },
      deep: true,
    },
    searchBank: {
      handler(val) {
        this.GetBankByQuery(val);
      },
      deep: true,
    },
  },
  created() {
    this.GetBankByQuery();
  },
};
</script>
